import React, { useState } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

// ============= ORDER DETAILS MODAL COMPONENT =============
const OrderDetailsModal = ({
  isOpen,
  toggle,
  onSubmit,
  totalPrice,
  totalItems,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
    specialInstructions: "",
    deliveryType: "delivery",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phoneNumber.trim())
      newErrors.phoneNumber = "Phone number is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!/^\d{10}$/.test(formData.phoneNumber.replace(/\D/g, ""))) {
      newErrors.phoneNumber = "Phone number must be 10 digits";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (formData.deliveryType === "delivery" && !formData.address.trim()) {
      newErrors.address = "Address is required for delivery";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      onSubmit(formData);
      setFormData({
        name: "",
        phoneNumber: "",
        email: "",
        address: "",
        city: "",
        zipCode: "",
        specialInstructions: "",
        deliveryType: "delivery",
      });
    }
  };

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      backdropClassName="bg-dark bg-opacity-50"
      className="shadow-lg animate__animated animate__slideInRight bg-white rounded-start"
      id="offcanvasRight"
    >
      {/* OffcanvasHeader for mobile */}
      <OffcanvasHeader className="d-block d-sm-none">
        <div className="d-flex justify-content-between align-items-center w-100 rounded-top">
          <button className="btn btn-sm btn-light" onClick={toggle}>
            <i class="bx bx-chevron-left"></i>
          </button>
          <div className="d-flex align-items-center text-center justify-content-center w-100 gap-2">
            <i className="ri-stack-line"></i>
            <h5 className="mb-0"> Order Details</h5>
          </div>
        </div>
      </OffcanvasHeader>
      <div
        className="position-absolute d-none d-sm-block"
        style={{ left: "-40px", top: "10px" }}
      >
        <button className="btn btn-sm btn-light" onClick={toggle}>
          <i className="ri-close-line"></i>
        </button>
      </div>
      {/* Desktop Header */}
      <div className="d-none d-sm-flex justify-content-start align-items-center p-3 shadow-sm rounded-top">
        <i className="ri-stack-line"></i>
        <h5 className="mb-0 ms-2"> Order Details</h5>
      </div>

      <OffcanvasBody>
        <div
          style={{
            marginBottom: "20px",
            backgroundColor: "#f9f9f9",
            padding: "12px",
            borderRadius: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "8px",
            }}
          >
            <span style={{ color: "#666" }}>Items: {totalItems}</span>
            <span className="fw-bold">Total: Rs. {totalPrice}</span>
          </div>
        </div>

        {/* Name */}
        <FormGroup>
          <Label className="fw-bold" for="name">
            Full Name *
          </Label>
          <Input
            type="text"
            name="name"
            id="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            invalid={!!errors.name}
            style={{ borderColor: errors.name ? "#dc3545" : "" }}
          />
          {errors.name && (
            <small style={{ color: "#dc3545" }}>{errors.name}</small>
          )}
        </FormGroup>

        {/* Phone Number */}
        <FormGroup>
          <Label className="fw-bold" for="phoneNumber">
            Phone Number *
          </Label>
          <Input
            type="tel"
            name="phoneNumber"
            id="phoneNumber"
            placeholder="9800000000"
            value={formData.phoneNumber}
            onChange={handleChange}
            invalid={!!errors.phoneNumber}
            style={{ borderColor: errors.phoneNumber ? "#dc3545" : "" }}
          />
          {errors.phoneNumber && (
            <small style={{ color: "#dc3545" }}>{errors.phoneNumber}</small>
          )}
        </FormGroup>

        {/* Special Instructions */}
        <FormGroup>
          <Label className="fw-bold" for="specialInstructions">
            Special Instructions (Optional)
          </Label>
          <Input
            type="textarea"
            name="specialInstructions"
            id="specialInstructions"
            placeholder="e.g., No onions, Extra spicy, etc."
            value={formData.specialInstructions}
            onChange={handleChange}
            style={{ minHeight: "70px" }}
          />
        </FormGroup>
      </OffcanvasBody>
      <div className="d-flex justify-content-end gap-2 mt-2">
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>

        <Button
          color="danger"
          style={{ backgroundColor: "#ff7900", border: "none" }}
          onClick={handleSubmit}
        >
          <i className="bx bx-check me-1" />
          Confirm Order
        </Button>
      </div>
    </Offcanvas>
  );
};

export default OrderDetailsModal;